import { extend } from 'vee-validate';

extend('max', {
    validate(value, { max }: any) {
        return value.length <= max;
    },
    params: ['max'],
    message: 'The {_field_} field cannot exceed {max} characters'
});
